import React from "react";
import styled from "@emotion/styled";
import parse, { domToReact } from "html-react-parser";
import { Heading, Link, Text } from "theme-ui";

const RichContent = ({ html }) => {
  const options = {
    replace: ({ name, children }) => {
      switch (name) {
        case "p":
          return (
            <Text as="p" sx={{ mb: 3 }} variant="blog">
              {domToReact(children)}
            </Text>
          );
        case "h1":
          return (
            <Heading variant="display" as="h1">
              {domToReact(children)}
            </Heading>
          );
        case "h2":
          return (
            <Heading variant="displaySmall" as="h2" sx={{ mt: 5, mb: 4 }}>
              {domToReact(children)}
            </Heading>
          );
        case "h3":
          return (
            <Heading as="h3" sx={{ mt: 5, mb: 4 }}>
              {domToReact(children)}
            </Heading>
          );
        case "h4":
          return (
            <Heading variant="headingSmall" as="h4">
              {domToReact(children)}
            </Heading>
          );
        case "h5":
          return (
            <Heading variant="lead" as="h5">
              {domToReact(children)}
            </Heading>
          );
        case "h6":
          return (
            <Heading variant="leadSmall" as="h6">
              {domToReact(children)}
            </Heading>
          );
        case "a":
          return (
            <Link as="a">
              {domToReact(children)}
            </Link>
          );
      }
    },
  };
  return <Wrapper>{parse(html, options)}</Wrapper>;
};

const Wrapper = styled.div`
  width: 100%;
  & > *:first-child {
    margin-top: 0;
  }
`;

export default RichContent;
